import { Directive, EmbeddedViewRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import permissions from 'app/models/Permissions';
import { SessionStorageService } from '../../services/session-storage.service';
import { forkJoin } from 'rxjs';
import Utils from '../utils';

@Directive({ selector: '[withPermissions]' })
export class WithPermissionsDirective {
  private context: WithPermissionsDirectiveContext = { $implicit: ko.observable({}) };
  private viewRef: EmbeddedViewRef<WithPermissionsDirectiveContext> = undefined;

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<WithPermissionsDirectiveContext>,
    private sessionStorageService: SessionStorageService) {}

  // This is a structural directive using structural directive shorthand https://angular.dev/guide/directives/structural-directives
  @Input()
  public set withPermissionsOf(permissionsToCheck: string[]) {
    const hasPermission = this.context.$implicit;
    for (const permission of permissionsToCheck) {
      hasPermission()[permission] = ko.observable(false);
    }
    forkJoin([
      this.sessionStorageService.getPartnerUsers(),
      this.sessionStorageService.getPartner(),
      this.sessionStorageService.getUser()
    ])
    .subscribe(([currentPartnerUsers, partner, user]) => {
      for (const permission of permissionsToCheck) {
        hasPermission()[permission](Utils.hasPermission(partner, currentPartnerUsers, permissions[permission], user));
      }

      hasPermission.valueHasMutated();
    });

    if (!this.viewRef) {
      this.viewContainer.clear();
      this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef, this.context);
    }
  }
}

interface WithPermissionsDirectiveContext { $implicit: KnockoutObservable<Record<string,KnockoutObservable<boolean>>> }